// Admin -> Settings (SettingsPage + IntegrationsPanel), uz
export default {
  title: "Sozlamalar",
  subtitle: "Butun kompaniya qoidalari · har o'zgarish audit jurnaliga yoziladi",
  ownerOnlyTitle: "Sozlamalarni faqat egasi o'zgartira oladi",
  ownerOnlyDesc: "Holatlar, biriktirish qoidalari, KPI va xavfsizlik sozlamalarini yangilash uchun egasiga murojaat qiling.",
  sections: {
    statuses: "Holatlar va sabablar",
    assignment: "Biriktirish",
    kpi: "KPI va bonus",
    expenses: "Budjet",
    security: "Xavfsizlik",
    documents: "Hujjatlar",
    problems: "Driver qoidalari",
    integrations: "Integratsiyalar",
  },
  problems: {
    title: "Muammoli driverlar",
    formTitle: "Saqlashda majburiy",
    formHint: "Ism doim majburiy. Bu maydonlar driver yaratilganda to'ldirilishi shart; eski yozuvlar tahrirda saqlanaveradi.",
    lostReason: "Driver yo'qotilganda sabab majburiy",
    lostReasonHint: "Rad etildi, qiziqmadi, ketdi.",
    receiptHint: "Xarajatga chek majburiymi -- shu bo'limda:",
    subtitle: "Qaysi driver \"e'tibor kerak\" hisoblanadi. Shu qoidalar ro'yxat filtri, qatordagi belgi va bosh sahifada ishlaydi.",
    requiredTitle: "Majburiy profil maydonlari",
    requiredHint: "Shulardan biri bo'sh bo'lsa driver \"profil to'liq emas\" deb belgilanadi.",
    fromStatus: "Qaysi bosqichdan talab qilinadi",
    fromStatusHint: "Oldingi bosqichlar tekshirilmaydi: yangi lead'da faqat ism va telefon bo'lishi mumkin.",
    expiringDays: "Hujjat muddati tugayapti (kun)",
    expiringHint: "CDL, tibbiy karta va yuklangan hujjatlar.",
    staleHint: "\"Uzoq bog'lanilmagan\" va \"bosqichda qotib qolgan\" uchun {{days}} kunlik chegara shu bo'limda:",
    fields: { phone: "Telefon", email: "Email", state: "Shtat", city: "Shahar", date_of_birth: "Tug'ilgan sana", cdl_class: "CDL klassi", cdl_state: "CDL shtati", cdl_number: "CDL raqami", cdl_expires: "CDL muddati", medical_card_expires: "Tibbiy karta muddati", experience_months: "Tajriba", driver_type: "Driver turi", freight_type: "Yuk turi", endorsements: "Ruxsatnomalar", equipment: "Texnika", home_time: "Uyga qaytish", desired_pay: "Kutilgan maosh", available_from: "Qachondan tayyor" },
  },
  saved: "Sozlamalar saqlandi",
  savedDesc: "Har bir o'zgarish audit jurnaliga yoziladi.",
  conflict: "Sozlamalarni boshqa kimdir o'zgartirdi. Qayta yuklandi.",
  saveFailed: "Sozlamalarni saqlab bo'lmadi.",
  unsaved_one: "{{count}} saqlanmagan o'zgarish",
  unsaved_other: "{{count}} saqlanmagan o'zgarish",
  statuses: {
    title: "Holatlar",
    subtitle: "Voronka bosqichlari o'zgarmas: Yangi → Bog'lanildi → Mos → Hujjatlar → Topshirildi → Tekshiruv → Orientatsiya → Ishga olindi.",
    staleDays: "Karta qotib qolgan hisoblanadi (kun)",
    staleDaysHint: "Haydovchi bir bosqichda shundan uzoq tursa, voronkadagi karta qizaradi.",
    rejection: "Rad etish sabablari",
    rejectionDesc: "Haydovchi (carrier tomonidan) rad etilganda majburiy.",
    lost: "Yo'qotish sabablari",
    lostDesc: "“Qiziqmadi” uchun majburiy.",
    quit: "Ketish sabablari",
    quitDesc: "Ishga olingan haydovchi ketganda majburiy.",
    newReason: "Yangi sabab",
  },
  assignment: {
    title: "Haydovchi egaligi",
    period: "Egalik muddati",
    days: "kun",
    periodHint: "Haydovchi uni birinchi qo'shgan recruiterda qoladi.",
    whenEnds: "Muddat tugaganda",
    extend: "Oxirgi {{days}} kunda faollik bo'lsa, avtomatik uzaytirish",
    returnToPool: "Filial pooliga qaytarish",
    askManager: "Filial menejeri hal qilsin (bildirishnoma)",
    window: "Faollik oynasi (kun)",
    transferHint: "Menejer haydovchini muddatidan oldin o'tkazishi mumkin (audit jurnaliga yoziladi).",
    duplicates: "Dublikat tekshiruvi",
    phone: "Telefon raqami",
    phoneHint: "bir formatda solishtiriladi (+1 555 010 0142)",
    cdl: "CDL raqami + shtat",
    email: "Email",
    onMatch: "Moslik topilganda",
    blockShowOwner: "Yaratishni to'xtatib, joriy egasini ko'rsatish",
    allowWarning: "Ogohlantirish bilan ruxsat berish",
    blockRecruiters: "Recruiterga bloklash, menejer va owner tasdiqlab qo'sha oladi",
    always: "Telefon va CDL raqami — doim: bitta raqam faqat bitta faol driverda bo'la oladi (pastdagi tanlovdan qat'i nazar bloklaydi).",
    phoneSecondary: "Qo'shimcha telefon",
    phoneSecondaryHint: "ikkala raqam boshqa driverlarning ikkala raqami bilan solishtiriladi",
    name: "Ism-familiya",
    nameHint: "faqat ogohlantiradi: bir xil ismli boshqa odam bo'lishi mumkin. Import qilingan driverlarda telefon yo'q — ularni faqat shu topadi",
    policyHint: "Qo'shimcha telefon va email'ga tegishli. Ogohlantirishda foydalanuvchi \"bu boshqa odam\" deb tasdiqlaydi (Audit log'ga yoziladi)."
  },
  kpi: {
    title: "Bonus qoidasi",
    subtitle: "Bonuslar holat tarixidan hisoblanadi va Byudjet → Bonuslar da tasdiqlanadi.",
    ruleName: "Qoida nomi",
    currency: "Valyuta",
    perHire: "Har tasdiqlangan ishga olish",
    monthlyGoal: "Har recruiter uchun oylik ishga olish maqsadi",
    monthlyGoalHint: "Maqsad halqasi widgetida ko'rinadi; 0 — maqsad yo'q",
    stayed30: "30 kun qoldi",
    stayed60: "60 kun qoldi",
    stayed90: "90 kun qoldi",
    approver: "Bonuslarni kim tasdiqlaydi",
    retention: "Qolish tekshiruvlari (kun)",
    retentionHint: "Vergul bilan, masalan 30, 60, 90",
    expiry: "Muddat eslatmalari",
    expiryDesc: "CDL va tibbiy karta muddati tugashidan oldin avtomatik eslatmalar.",
    daysBefore: "Muddatdan necha kun oldin",
    daysBeforeHint: "Vergul bilan, masalan 30, 7",
  },
  expenses: {
    title: "Xarajat toifalari",
    subtitle: "Budjet → Xarajatlar va Pul → Chiqimda ishlatiladi. Komissiya % ixtiyoriy: xarajat to'langanda qo'shiladi.",
    newCategory: "Yangi toifa",
    rules: "Xarajat qoidalari",
    receipt: "Chek majburiy",
    receiptHint: "Cheksiz xarajatni yuborib bo'lmaydi",
    approver: "Xarajatlarni kim tasdiqlaydi",
    alert: "Byudjet ogohlantirishi (rejaning % i)",
    alertHint: "Filial shundan oshsa, egasiga xabar beriladi",
    autoLimit: "Tasdiqsiz chegara",
    autoLimitHint: "Menejer xarajati shu summagacha o'zi tasdiqlanadi; 0 — har doim tasdiq kerak",
  },
  income: {
    title: "Kirim kategoriyalari",
    subtitle: "Pul → Kirimda ishlatiladi (ixtiyoriy). Komissiya % ixtiyoriy: tushgan puldan ayriladi.",
    newCategory: "Yangi kategoriya",
  },
  security: {
    twofa: "Ikki bosqichli tasdiqlash",
    twofaDesc: "Bu rollardagi xodimlar ishlashdan oldin autentifikator ilovasini sozlashi shart va uni o'chira olmaydi.",
    sessions: "Sessiya va kirish",
    sessionHours: "Sessiya muddati (soat)",
    maxAttempts: "Bloklashgacha xato urinishlar",
    lockMinutes: "Blok davomiyligi (daqiqa)",
    applyNext: "Sessiya va blok sozlamalari keyingi kirishdan kuchga kiradi.",
    public: "Ochiq sahifalar",
    publicDesc: "3-bosqich",
    applyForm: "Haydovchi ariza formasi (/apply)",
    portalPhone: "Carrier portalida haydovchi telefoni ko'rinadi",
    companyName: "Kompaniya nomi",
  },
  list: {
    rateHead: "Komissiya, %",
    rateAria: "{{item}} uchun komissiya, %",
    remove: "{{item}} ni o'chirish",
    empty: "Ro'yxat bo'sh",
    add: "Qo'shish",
  },
  integrations: {
    pill: { error: "Xato", connected: "Ulangan", disabled: "O'chirilgan", notConfigured: "Sozlanmagan" },
    conflict: "Boshqa oynada o'zgartirildi. Qayta yuklandi.",
    saveFailed: "Saqlab bo'lmadi.",
    notConfigured: "Verifix sozlanmagan",
    notConfiguredDesc: "Avval .env da VERIFIX_CLIENT_ID / VERIFIX_CLIENT_SECRET va filial_id ni kiriting.",
    done: "{{kind}}: bajarildi",
    failed: "{{kind}} bajarilmadi",
    requestFailed: "So'rov bajarilmadi.",
    subtitle: "Filial: {{filial}} · oxirgi sinxron {{when}} · {{n}} xodim",
    clientId: "Client ID",
    clientIdHint: "Client secret serverdagi .env da turadi (hech qachon ko'rsatilmaydi)",
    notSet: "— .env da kiritilmagan",
    filialId: "Filial ID",
    filialHint: "Verifix tashkiloti (filial_id sarlavhasi)",
    test: "Ulanishni tekshirish",
    syncNow: "Hozir sinxronlash",
    pullSalaries: "Maoshlarni olish",
    pushBonuses: "Bonuslarni yuborish",
    enabled: "Yoqilgan",
    lastError: "Oxirgi xato",
    whatToSync: "Nimani sinxronlash",
    syncEmployees: "Xodimlar va bo'limlar → Xodimlar, Filiallar",
    hourly: "har soat",
    syncSalaries: "Maoshlar ← Verifix",
    monthlyPro: "har oy, Pro",
    pushBonusesLabel: "Tasdiqlangan bonuslar → Verifix bir martalik to'lov",
    syncAttendance: "Davomat → Hisobotlar",
    daily: "har kuni",
    lastRun: "Oxirgi ishga tushish",
    ok: "ok",
    runFailed: "xato",
    pullTitle: "Verifix dan maoshlarni olish",
    pullDesc: "Faqat to'lanmagan maoshlar yangilanadi.",
    pull: "Olish",
    month: "Oy",
    mappingSaved: "Moslik saqlandi",
    mappingFailed: "Moslikni saqlab bo'lmadi.",
    mapDivision: "Moslik: Verifix bo'limi → filial",
    mapEmployee: "Moslik: Verifix xodimi → foydalanuvchi",
    mapSubtitle: "{{n}} faol · {{unmatched}} mos kelmagan",
    hideMatched: "Mos kelganlarni yashirish",
    showMatched: "Mos kelganlarni ko'rsatish",
    afterSync: "Mosliklar birinchi sinxrondan keyin paydo bo'ladi.",
    nothingSynced: "Hali hech narsa sinxronlanmagan. “Hozir sinxronlash” ni bosing.",
    allMatched: "Hammasi mos keldi.",
    colVerifix: "Verifix",
    colOurs: "Bizda",
    colMapTo: "Moslashtirish",
    unmatched: "— Mos kelmagan",
    none: "— yo'q —",
    branchSuffix: "(filial)",
    errors: "Xatolar ({{n}})",
    errorsDesc: "har bir sinxron audit jurnaliga yoziladi",
  },
  google: {
    title: "Google akkaunt",
    subtitle: "Import Google Sheets'ni shu akkaunt nomidan o'qiydi · faqat o'qish",
    pill: { connected: "Ulangan", reauth: "Qayta ulash kerak", notConnected: "Ulanmagan", notConfigured: "Sozlanmagan" },
    notConfiguredDesc: "Google akkauntni ulash uchun Google OAuth client kerak. Dasturchi uni Google Cloud'da yaratadi va .env ga GOOGLE_OAUTH_CLIENT_ID hamda GOOGLE_OAUTH_CLIENT_SECRET qo'shadi. OAuth client'ga quyidagi redirect URI'ni kiriting:",
    redirectUri: "Ruxsat etilgan redirect URI",
    setupDoc: "Batafsil qadamlar: docs/09-ishga-tushirish.md, «Google akkaunt» bo'limi.",
    whatFor: "Kompaniya jadvallari egasi bo'lgan yoki ularga kirish huquqi bor Google akkauntni ulang. Shundan keyin import jadvallarni havola orqali to'g'ridan-to'g'ri o'qiydi. Tizim jadvallaringizni hech qachon o'zgartirmaydi.",
    permission: { profile: "Akkaunt email va ismini ko'rish", sheets: "Google Sheets'ni o'qish (faqat o'qish)" },
    connect: "Google akkauntni ulash",
    connectFailed: "Google ulanishini boshlab bo'lmadi.",
    connectedBy: "{{who}} ulagan",
    access: "Ruxsat",
    sheetsReadOnly: "Google Sheets, faqat o'qish",
    noSheetsAccess: "Google Sheets'ga ruxsat yo'q — qayta ulab, ruxsat bering",
    lastUsed: "Oxirgi foydalanish",
    neverUsed: "Hali ishlatilmagan",
    switchAccount: "Boshqa akkauntni ulash",
    reconnect: "Qayta ulash",
    disconnect: "Uzish",
    disconnected: "Google akkaunt uzildi",
    disconnectFailed: "Uzib bo'lmadi.",
    disconnectTitle: "Google akkaunt uzilsinmi?",
    disconnectDesc: "Tizim {{email}} akkauntining Google Sheets'iga kira olmay qoladi. Google akkaunt qayta ulanmaguncha havola orqali import ishlamaydi. Import qilingan ma'lumotlar saqlanib qoladi.",
    reauthTitle: "Google ruxsatining muddati tugagan",
    reauthDesc: "Google saqlangan ruxsatni rad etdi (parol o'zgargan yoki ruxsat olib tashlangan). Jadvallarni yana o'qish uchun akkauntni qayta ulang.",
    technical: "Texnik ma'lumot",
    clientId: "Client ID",
    copy: "Nusxalash",
    copied: "Nusxalandi",
    copyFailed: "Nusxalab bo'lmadi. Matnni belgilab, o'zingiz nusxalang.",
    result: {
      connected: "Google akkaunt ulandi",
      connectedDesc: "Endi import Google Sheets'ni havola orqali o'qiy oladi.",
      cancelled: "Google ulanishi bekor qilindi.",
      failed: "Google akkaunt ulanmadi",
    },
    reason: {
      state: "Ulanish so'rovining muddati o'tgan yoki mos kelmadi. Shu sahifadan qaytadan boshlang.",
      scope: "Google Sheets'ga ruxsat berilmadi. Qayta ulang va Google Sheets belgisini olib tashlamang.",
      forbidden: "Google akkauntni faqat owner ulay oladi.",
      denied: "Google ruxsat bermadi.",
      redirect_uri_mismatch: "Redirect URI Google OAuth client'da ro'yxatdan o'tmagan. Pastdagi «Texnik ma'lumot» dagi URI'ni Google Cloud'da qo'shing.",
      invalid_client: "Google client ID yoki secret'ni qabul qilmadi. .env dagi GOOGLE_OAUTH_CLIENT_ID va GOOGLE_OAUTH_CLIENT_SECRET'ni tekshiring.",
      invalid_grant: "Google kodi eskirdi. Qayta ulab ko'ring.",
      no_refresh_token: "Google oflayn ruxsat bermadi. Google akkauntingizda ilovani olib tashlang (Xavfsizlik → Uchinchi tomon ilovalari) va qayta ulang.",
      network: "Google bilan bog'lanib bo'lmadi. Internet aloqasini tekshirib, qayta urinib ko'ring.",
      userinfo: "Google akkaunt emailini o'qib bo'lmadi. Qayta urinib ko'ring.",
      unknown: "Xato kodi: {{code}}",
    },
  },
  payments: {
    title: "Carrier to'lovlari",
    subtitle: "Carrier har bir ishga olingan driver uchun kompaniyaga to'laydigan pul.",
    dueDays: "Driver ishga chiqqandan keyin (kun)",
    dueDaysHint: "Yangi ishga olishlarga qo'llanadi; mavjudlarining sanasi o'zgarmaydi",
  },
  documents: {
    title: "Hujjat turlari",
    subtitle: "Recruiter driverdan nimalarni yig'adi. Majburiy turlar \"Topshirilgan\" uchun hisoblanadi; muddatli turlarda amal qilish sanasi ko'rsatiladi.",
    name: "Nomi",
    key: "Kalit",
    required: "Majburiy",
    expires: "Muddati bor",
    remove: "{{name}} ni olib tashlash",
    protectedHint: "CDL va medical card qoladi: AI o'qish va muddat eslatmalari shularga bog'langan.",
    newType: "Yangi hujjat turi",
    add: "Qo'shish",
    blockTitle: "Carrier'ga topshirish",
    block: "Majburiy hujjatlar to'liq bo'lmaguncha \"Topshirilgan\" ga o'tkazib bo'lmasin",
    blockHint: "O'chiq bo'lsa status oynasi faqat yetishmayotgan hujjatlar haqida ogohlantiradi.",
    ocrNote: "AI o'qish (Gemini) Integratsiyalar bo'limida sozlanadi.",
  },
  ocr: {
    title: "AI hujjat o'qish",
    subtitle: "Gemini CDL va medical card fotosini o'qib, profil maydonlarini taklif qiladi. Odam qabul qilmaguncha hech narsa o'zgarmaydi.",
    pill: { on: "Yoqiq", off: "O'chiq", notConfigured: "Sozlanmagan" },
    notConfigured: "Hali ulanmagan. Serverdagi .env da: Vertex AI + Application Default Credentials (GEMINI_USE_VERTEX=1, GOOGLE_CLOUD_PROJECT) yoki AI Studio pullik tier kaliti (GEMINI_API_KEY) — docs/09-ishga-tushirish.md.",
    model: "Model",
    auth: "Ulanish",
    authVertex: "Vertex AI · {{project}} loyihasi (Application Default Credentials)",
    authKey: "AI Studio API kaliti",
    enabled: "Yuklangan hujjatlarni avtomatik o'qish",
    kinds: "O'qiladigan hujjat turlari",
    month: "Shu oy",
    monthLine: "{{documents}} ta o'qildi · {{failed}} ta o'qilmadi · {{input}} kirish / {{output}} chiqish token",
    cost: "≈ ${{cost}}",
    costUnknown: "bu model narxi jadvalda yo'q",
    privacy: "Faqat pullik tier: Google pullik so'rovlarda o'rgatmaydi. SSN hech qachon o'qilmaydi; ariza yuborilmaydi.",
    saved: "AI o'qish sozlamalari saqlandi",
  },
  sheets: {
    title: "Google Sheets nusxasi",
    subtitle: "Hozirgi holat eski jadval ko'rinishida: Partners, har filial uchun Database varag'i va Pipeline",
    pill: { on: "Yoqilgan", paused: "To'xtatilgan", error: "Xato", off: "Ulanmagan" },
    download: "Yuklab olish (.xlsx)",
    notConfiguredDesc: "Avtomatik nusxa uchun Google service account kerak. Dasturchi uni bir marta sozlaydi: docs/09-ishga-tushirish.md, “Google Sheets nusxasi” bo'limi. Ungacha faylni yuklab oling — u Excel'da yoki Google Drive'da ochiladi.",
    step1: "Google Sheets'da bo'sh jadval oching.",
    step2: "Uni (Share tugmasi) shu emailga Editor qilib ulashing:",
    step3: "Jadval havolasini qo'ying:",
    link: "Jadval havolasi",
    connect: "Ulash",
    firstWrite: "Jadval birinchi marta yozilmoqda…",
    connected: "Jadval ulandi va to'ldirildi",
    untitled: "Jadval",
    updated: "Yangilangan: {{when}}",
    notYet: "Hali yozilmagan",
    connectedBy: "ulagan: {{who}}",
    syncNow: "Hozir yangilash",
    synced: "Jadval yangilandi",
    errorTitle: "Oxirgi yangilash bajarilmadi",
    auto: "Avtomatik yangilash",
    autoHint: "o'zgarishdan keyin 2 daqiqa ichida",
    rows_one: "{{count}} qator",
    rows_other: "{{count}} qator",
    disconnect: "Uzish",
    disconnectTitle: "Jadvalni uzasizmi?",
    disconnectDesc: "Platforma uni boshqa yangilamaydi. Jadvalning o'zi va undagi ma'lumot Google Drive'da qoladi.",
    disconnected: "Jadval uzildi",
    oneWay: "Bir tomonlama nusxa: jadvalda qilingan tahrir keyingi yangilanishda ustidan yoziladi. Jadvalga kirish huquqi bor har kim hamma driverlarni ko'radi — ehtiyot bo'lib ulashing.",
  },
};
